@if (captionKey() || caption()) {
  <span class="segmented-button__caption" [id]="captionId">
    {{ captionKey() ? (captionKey() | translate) : caption() }}
  </span>
}

<mat-button-toggle-group
  class="segmented-button"
  [ngClass]="'segmented-button--' + size()"
  [value]="value()"
  [disabled]="disabled()"
  [hideSingleSelectionIndicator]="true"
  [attr.aria-label]="captionKey() || caption() ? null : ariaLabel() || null"
  [attr.aria-labelledby]="captionKey() || caption() ? captionId : null"
  (change)="onChange($event)"
>
  @for (option of options(); track option.value) {
    <mat-button-toggle
      [value]="option.value"
      [disabled]="option.disabled ?? false"
      [attr.aria-label]="option.ariaLabel || null"
      [matTooltip]="option.tooltipKey ? (option.tooltipKey | translate) : (option.tooltip ?? '')"
    >
      @if (option.icon) {
        <mat-icon class="segmented-button__icon">{{ option.icon }}</mat-icon>
      }
      @if (option.labelKey || option.label) {
        <span class="segmented-button__label">
          {{ option.labelKey ? (option.labelKey | translate) : option.label }}
        </span>
      }
    </mat-button-toggle>
  }
</mat-button-toggle-group>
